import { AgreementType } from '../types';

const getAgreementTypeName = (type: AgreementType) => {
  let agreementTypeName: string;

  switch (type) {
    case AgreementType.GENERAL_T_AND_CS:
      agreementTypeName = 'General T&Cs';
      break;
    case AgreementType.PRIVACY_NOTICE:
      agreementTypeName = 'Privacy Notice';
      break;
    case AgreementType.ANNEX_1:
      agreementTypeName = 'Annex 1';
      break;
    case AgreementType.ANNEX_2:
      agreementTypeName = 'Annex 2';
      break;
    case AgreementType.ANNEX_3:
      agreementTypeName = 'Annex 3';
      break;
    case AgreementType.ANNEX_4:
      agreementTypeName = 'Annex 4';
      break;
    case AgreementType.ANNEX_5:
      agreementTypeName = 'Annex 5';
      break;
    case AgreementType.ANNEX_6:
      agreementTypeName = 'Annex 6';
      break;
    case AgreementType.ANNEX_7:
      agreementTypeName = 'Annex 7';
      break;
    case AgreementType.ANNEX_8:
      agreementTypeName = 'Annex 8';
      break;
    default:
      agreementTypeName = type;
      break;
  }

  return agreementTypeName;
};

export default getAgreementTypeName;
